import Model from 'modules/reports/orm/Model'

export default class ReportFolder extends Model {
  id: any
  name: string

  get deleteable() {
    return this.id !== 'all'
  }
}
